import { PrismLoadingBar, PrismTooltipHeader } from '@mylighthouse/prism-ember';
import dayjs from 'dayjs';
import { t } from 'ember-intl';
import { and } from 'ember-truth-helpers';
import GeneralTooltipsTooltipRatesBodySection from 'lumen/components/general/tooltips/tooltip-rates-body-section';
import GeneralTooltipsTooltipRatesGeneric from 'lumen/components/general/tooltips/tooltip-rates-generic';
import MarketRatesTooltipsTooltipMarketratesHeaderSection from 'lumen/components/market/rates/tooltips/tooltip-marketrates-header-section';

// @ts-expect-error: Incorrect type
export default class MarketRatesTooltipsTooltipMarketratesTable extends GeneralTooltipsTooltipRatesGeneric {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get compRatesArray() {
    // @ts-expect-error: Incorrect type
    const arrCompetitorRates = [];

    // @ts-expect-error: Incorrect type
    let competitorsAndOwnHotel = [];
    if (this.args.competitorsForCurrentHotelAndOTA) {
      competitorsAndOwnHotel = [
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        ...competitorsAndOwnHotel,
        ...this.args.competitorsForCurrentHotelAndOTA,
      ];
    }
    // @ts-expect-error: Incorrect type
    competitorsAndOwnHotel.forEach((hotel) => {
      const rate = this.rate(hotel);
      if (!rate) {
        return;
      }
      const rateIcons = this.getRateIcons(rate);
      // @ts-expect-error: Incorrect type
      const allChannelsOtas = [];
      let roomName = '';

      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      roomName = rate.roomName;

      arrCompetitorRates.push({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        hotel,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        isOwnHotel: hotel.id === this.args.ownHotelId,
        rate: this.hotelAndMarketService.formatRateObject(rate),
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        sortValue: rate.value === 0 ? Number.MAX_SAFE_INTEGER : rate.value,
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value: rate.value,
        rateIcons,
        // @ts-expect-error: Incorrect type
        allChannelsOtas,
        roomName,
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        extractDatetime: dayjs.utc(rate.extractDatetime).unix(),
      });
    });
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return arrCompetitorRates.sort((a, b) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (a.sortValue === b.sortValue) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
        return a.hotel?.name?.localeCompare(b.hotel.name)
          ? // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            a.hotel.name.localeCompare(b.hotel.name)
          : // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            a.hotel.name - b.hotel.name;
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return a.sortValue - b.sortValue;
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedMedian() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { median } = this;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return median
      ? // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.hotelAndMarketService.formatRateObject(median, true, false)
      : median;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get median() {
    // @ts-expect-error: Incorrect type
    const rateValues = [];
    // @ts-expect-error: Incorrect type
    this.args.rates.forEach((rate) => {
      if (rate.value > 0 && rate.hotelinfo?.id !== this.args.ownHotelId) {
        rateValues.push(rate);
      }

      return null;
    });
    if (rateValues.length) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      rateValues.sort((a, b) => a.value - b.value);
      const mid = Math.floor(rateValues.length / 2);
      if (rateValues.length % 2) {
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return rateValues[mid];
      }
      const medianValue =
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (rateValues[mid - 1].value + rateValues[mid].value) / 2.0;
      return {
        id: 'temp_id',
        value: medianValue,
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        currency: rateValues[mid - 1].currency,
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        message: rateValues[mid - 1].message,
      };
    }

    return null;
  }

  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  rate(hotel) {
    const { rates } = this.args;
    if (rates) {
      let result;
      rates.forEach((rate) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (rate.hotelinfo?.id === hotel.id) {
          result = rate;
        }
      });
      return result;
    }

    return null;
  }

  <template>
    {{#if @isLoading}}
      <PrismTooltipHeader>
        <PrismLoadingBar />
      </PrismTooltipHeader>
    {{else}}
      <PrismTooltipHeader>
        <span>
          {{#if this.currentDate}}
            {{this.currentDate}}
          {{/if}}
          {{#if (and this.isFutureDate this.updateTimeDate)}}
            &nbsp;({{t "general.updated"}}
            {{this.updateTimeDate}})&nbsp;
          {{/if}}
        </span>
      </PrismTooltipHeader>
      <MarketRatesTooltipsTooltipMarketratesHeaderSection
        @formattedMedian={{this.formattedMedian}}
      />
      {{! @glint-expect-error: Incorrect type }}
      <GeneralTooltipsTooltipRatesBodySection
        @compRatesArray={{this.compRatesArray}}
      />
    {{/if}}
  </template>
}
